/** @type {{ enabled: boolean; godMode: boolean; lastLogMs: number }} */
export const debugState = {
  enabled: false,
  godMode: false,
  lastLogMs: 0,
};
